// Mock data for fitness blog
export const heroContent = {
  title: "Transformez votre salon en salle de sport : Le guide ultime pour des abdos sculptés sans abonnement",
  subtitle: "Vous manquez de temps ? Votre budget ne permet pas un abonnement en salle ? Vous ne savez pas quel équipement acheter ?",
  description: "À la fin de cet article, vous disposerez d'un plan complet pour transformer votre maison en salle de sport et d'une routine d'entraînement efficace pour sculpter vos abdominaux.",
  image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b",
  imageAlt: "Femme faisant des exercices d'abdos dans un salon moderne"
};

export const systemeDItems = [
{
  id: 1,
  household: "Sac à dos lesté de livres",
  replacement: "Gilet lesté / Kettlebell",
  tips: "Remplissez votre sac à dos de livres ou de bouteilles d'eau pour créer une résistance ajustable. Assurez-vous que le poids est bien réparti.",
  image: "https://img.freepik.com/photos-gratuite/pile-livres-chaise_23-2148213835.jpg",
  alt: "sac à dos lesté par des gros livres",
},
{
  id: 2,
  household: "Packs d'eau (6 bouteilles)",
  replacement: "Haltères",
  tips: "Un pack de 6 bouteilles de 1,5L = environ 9kg. Parfait pour les curls, les élévations latérales et les exercices de core.",
  image: "https://images.pexels.com/photos/13055851/pexels-photo-13055851.jpeg",
  alt: "remplacer des halters par des bouteilles d'eau",
},
{
  id: 3,
  household: "Chaise ou bord de canapé",
  replacement: "Banc de musculation",
  tips: "Utilisez une chaise stable pour les dips, les relevés de jambes et les Bulgarian split squats. Vérifiez la stabilité avant chaque utilisation.",
  image: "https://images.unsplash.com/photo-1773910109561-1ebe8d3cc0d2",
  alt: "une chaise pour faire des dips",
},
{
  id: 4,
  household: "Torchons sur carrelage",
  replacement: "Roue à abdos (Sliding discs)",
  tips: "Placez vos mains ou pieds sur des torchons et glissez sur le carrelage pour un travail intense des abdominaux et du core.",
  image: "https://png.pngtree.com/thumb_back/fh260/background/20240417/pngtree-pile-of-colorful-warm-clothes-on-wooden-background-image_15660740.jpg",
  alt : "utilisez un torchon pour remplacer la roue à abdos",
}];


export const workoutRoutine = {
  title: "Routine Express : 15 Minutes pour une Sangle Abdominale Puissante",
  duration: "15 minutes",
  frequency: "3-4 fois par semaine",
  tip: "Les abdos se construisent à l'entraînement, mais se révèlent dans la cuisine.",
  exercises: [
  {
    id: 1,
    name: "Gainage (Plank)",
    duration: "3 x 45 secondes",
    rest: "15 secondes entre les séries",
    description: "Position de pompe sur les avant-bras. Gardez le corps aligné, contractez les abdos et les fessiers.",
    image: "https://images.unsplash.com/photo-1717821681365-36b0da044a75",
    alt: " position pour faire du gainage",
    tips: "Ne laissez pas vos hanches s'affaisser. Regardez le sol pour maintenir un alignement neutre de la colonne."
  },
  {
    id: 2,
    name: "Mountain Climbers",
    duration: "3 x 30 secondes",
    rest: "15 secondes entre les séries",
    description: "En position de pompe, ramenez alternativement les genoux vers la poitrine à un rythme soutenu.",
    image: "https://i0.wp.com/wbk.gna.mybluehost.me/newstartforme/wp-content/uploads/2022/03/Upper-Body-Bodyweight-Exercises-for-Weight-Loss.jpg?resize=800%2C533",
    alt: "Position pour faire des mountains climbers",
    tips: "Gardez le core engagé et les hanches basses. L'exercice doit être dynamique mais contrôlé."
  },
  {
    id: 3,
    name: "Hollow Body Hold",
    duration: "3 x 30 secondes",
    rest: "15 secondes entre les séries",
    description: "Allongé sur le dos, levez les épaules et les jambes à quelques centimètres du sol. Bras tendus au-dessus de la tête.",
    image: "https://swolverine.com/cdn/shop/articles/Hollow_body_holds_-_swolverine.jpg?v=1661132670&width=1024",
    alt: "position pour faire du hollow body hold",
    tips: "Pressez le bas du dos contre le sol. Si c'est trop difficile, pliez légèrement les genoux."
  },
  {
    id: 4,
    name: "Bicycle Crunches",
    duration: "3 x 20 répétitions (10 de chaque côté)",
    rest: "15 secondes entre les séries",
    description: "Allongé sur le dos, amenez le coude vers le genou opposé en alternance, comme si vous pédaliez.",
    image: "https://images.pexels.com/photos/8038625/pexels-photo-8038625.jpeg",
    alt: "position pour faire des bycle crunches", 
    tips: "Concentrez-vous sur la rotation du torse plutôt que de tirer sur votre nuque. Mouvement lent et contrôlé."
  }]

};

export const faqItems = [
{
  id: 1,
  question: "À quelle fréquence dois-je m'entraîner pour voir des résultats ?",
  answer: "Pour des résultats optimaux, entraînez vos abdominaux 3 à 4 fois par semaine, en laissant au moins un jour de repos entre les séances. La constance est plus importante que l'intensité. Combinez cet entraînement avec une alimentation équilibrée et un déficit calorique modéré si votre objectif est de rendre vos abdos visibles."
},
{
  id: 2,
  question: "Comment éviter les douleurs au dos pendant les exercices d'abdos ?",
  answer: "Les douleurs lombaires sont souvent causées par une mauvaise technique. Assurez-vous de : 1) Garder le bas du dos plaqué au sol lors des exercices au sol, 2) Engager activement vos abdominaux avant chaque mouvement, 3) Ne jamais tirer sur votre nuque avec les mains, 4) Respirer correctement (expirez lors de l'effort). Si la douleur persiste, consultez un professionnel de santé."
},
{
  id: 3,
  question: "Puis-je vraiment obtenir des résultats sans équipement professionnel ?",
  answer: "Absolument ! Les abdominaux sont des muscles qui répondent très bien au poids du corps. Les exercices isométriques (gainage) et dynamiques (mountain climbers) sont extrêmement efficaces. L'équipement professionnel peut ajouter de la variété, mais n'est pas nécessaire pour développer des abdominaux forts et visibles."
},
{
  id: 4,
  question: "Combien de temps avant de voir des résultats visibles ?",
  answer: "La visibilité des abdominaux dépend principalement de votre taux de masse grasse. Avec un entraînement régulier et une nutrition adaptée, vous devriez sentir vos abdos se renforcer en 2-3 semaines. Pour une visibilité esthétique, comptez 8-12 semaines selon votre point de départ. La patience et la constance sont essentielles."
},
{
  id: "privacy",
  question: "Quelle est votre politique de confidentialité ?",
  answer: "Nous respectons votre vie privée. Ce site utilise des cookies via Google AdSense pour proposer des publicités adaptées à vos centres d'intérêt. Aucune donnée personnelle n'est collectée à votre insu sur ce site."
  },
{
  id: "legal",
  question: "Mentions Légales",
  answer: "Ce site est édité à titre personnel. Hébergement : Vercel Inc. (650 California St, San Francisco, CA 94108). Le contenu est fourni à titre informatif sur le fitness à domicile."
}];


export const disclaimer = {
  title: "Avertissement Important",
  content: "Les informations présentées sur ce site sont fournies à titre éducatif uniquement. Je ne suis ni médecin, ni coach sportif certifié, ni nutritionniste. Avant de commencer tout programme d'exercice physique ou de modifier votre alimentation, il est fortement recommandé de consulter un médecin, un coach professionnel certifié et un nutritionniste qualifié. Chaque personne est unique et peut nécessiter des adaptations spécifiques. L'auteur de ce site décline toute responsabilité en cas de blessure ou de problème de santé résultant de l'application des conseils présentés."
};

export const articleMeta = {
  author: "\xC9quipe Fit",
  publishDate: "2025-01-15",
  readTime: "12 min",
  category: "Entraînement"
};
